// @flow

import React from "react";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import { ThemeProvider } from "styled-components";

// App Containers
import Home from "./containers";

// Bootstrap
import "bootstrap/dist/css/bootstrap.min.css";

// Common Theme
import { materialUITheme, styledComponentTheme } from "./common/theme";

class Root extends React.Component {
  render() {
    return (
      <MuiThemeProvider muiTheme={materialUITheme}>
        <ThemeProvider theme={styledComponentTheme}>
          <Home />
        </ThemeProvider>
      </MuiThemeProvider>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/Root.js